module.exports = __webpack_public_path__ + "static/media/manzate_200.886c15a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/preventiva/manzate_200.png
// module id = 2115
// module chunks = 3